import throttle from './helpers';

let header = document.querySelector('.header');
const $body = document.body;
let prevScroll = 0;
let prevHeader;

export default function getScrollPositionAndToggleStickyHeader(identifyHeader = false) {
    if (identifyHeader) {
        header = document.querySelector('.page-content-visible .header') || document.querySelector('.header');
    }
    if (!header) {
        return;
    }

    const scrollObject = {
        x: window.pageXOffset,
        y: window.pageYOffset
    };

    const headerHeight = header.clientHeight / 2;

    if (scrollObject.y > headerHeight &&
            !header.classList.contains('header-sticky') &&
            (scrollObject.y > prevScroll || prevHeader !== header)
    ) {
        header.classList.add('header-sticky');
        $body.classList.add('overscroll-color-bottom');
    } else if (
        scrollObject.y < (headerHeight + 1) &&
        header.classList.contains('header-sticky') &&
        (scrollObject.y < prevScroll || prevHeader !== header)
    ) {
        header.classList.remove('header-sticky');
        $body.classList.remove('overscroll-color-bottom');

        // ESPNWEB-2780: safari wasn't hiding sticky header - force re-layout
        $('.header').hide().css('display', 'flex');
    }

    prevScroll = scrollObject.y;
    prevHeader = header;
}

//Run once on initial load
if (header) {
    window.onscroll = throttle(getScrollPositionAndToggleStickyHeader, 500);
    getScrollPositionAndToggleStickyHeader();
}
